
export const getSnowFormData = async (param: any) => {
  const { default: axiosInstance } = await import("../../config/axiosInstance");
  const response = await axiosInstance.get(`/api/listSnowFormData`, {
    params: param,
  });
  return response;
};

export const SnowIdData = async (param: any) => {
   const { default: axiosInstance } = await import(
     "../../config/axiosInstance"
   );
  const { data } = await axiosInstance.get(`/api/findBySnowId`, {
    params: param,
  });
  return data;
};
export const RITMActivity = async (param: any) => {
   const { default: axiosInstance } = await import(
     "../../config/axiosInstance"
   );
  const { data } = await axiosInstance.get(`/api/getActivitiesByRITM`, {
    params: param,
  });
  return data;
};
